import APIKit from "../Allapis/Apikit/apikit";

export const getAppProducts = async (id) => {
  let res;
  let endpoint;
  if (id) {
    console.log(id);
    endpoint = `/admin/categories/${id}`;
    res = await APIKit.get(endpoint);
  } else {
    endpoint = `/admin/categories`;
    res = await APIKit.get(endpoint, {
      params: { type: "categories" },
    });
  }
  // console.log(endpoint);
  console.log(res, "res in api");
  return res.data;
};

export const createAppProducts = async (values) => {
  const res = await APIKit.post(`/admin/categories`, values);
  return res.data;
};

export const updateAppProducts = async (id, values) => {
  const res = await APIKit.post(`/admin/categories/${id}`, values);
  return res.data;
};

export const deleteAppProducts = async (prod_id) => {
  console.log(prod_id, "deleting id");
  const res = await APIKit.delete(`/admin/categories/${prod_id}`);
  console.log(res, "delete response");
  return res.data;
};
